import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LogoffComponent } from '../app/logoff/logoff.component';
import { PermissionGuard } from '@acpgruppe/essp-ui';
import { AuthGuard } from '@acpgruppe/essp-ui';

const appPathValue = 'vinfo';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '',
        pathMatch: 'full',
        redirectTo: appPathValue,
      },
      {
        path: 'start',
        pathMatch: 'full',
        redirectTo: appPathValue,
      },
      {
        path: appPathValue,
        // canActivate: [AuthGuard],
        canActivate: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./core/core.module').then((l) => l.CoreModule),
      },
      {
        path: 'logout',
        pathMatch: 'full',
        component: LogoffComponent,
      },
    ],
      {
        bindToComponentInputs: true
      }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
